const APP_VERSION = '2.0.3';
const IOS_VERSION = '2.0.1';
export const appUpdate = () => {
  const appVersion = localStorage.getItem('app_version') || undefined;
  if (appVersion === null || appVersion === undefined) {
    return;
  }
  if (navigator.userAgent.toLowerCase().indexOf('androidapp') !== -1) {
    console.log(`androidapp`);
    console.log(navigator.userAgent.toLowerCase().indexOf('androidapp') !== -1);
  }
  if (navigator.userAgent.toLowerCase().indexOf('iosapp') !== -1) {
    console.log('iosapp');
    console.log(navigator.userAgent.toLowerCase().indexOf('iosapp') !== -1);
  }
  // if (appVersion !== APP_VERSION) {
  //   console.log(appVersion);
  //   console.log(APP_VERSION);
  // }
  if (navigator.userAgent.toLowerCase().indexOf('androidapp') !== -1 && appVersion !== APP_VERSION) {
    //안드로이드앱 이면서 최신버전이 아닌경우
    if (window.confirm('최신버전의 앱이 업데이트되었습니다.\n스토어로 이동하여 설치하세요.')) {
      document.location = 'market://details?id=com.thehumanplus.shuffle';
    }
  } else if (navigator.userAgent.toLowerCase().indexOf('iosapp') !== -1 && appVersion !== IOS_VERSION) {
    // ios 이면서 최신버전이 아닌경우
    if (window.confirm('새로운 버전의 앱이 업데이트 되었습니다.\n스토어로 이동하여 설치하세요.')) {
      document.location = 'itms-apps://itunes.apple.com/app/id1509428401';
    }
  }
};
